enum DELIVERY_CANDIDATE_STATUS {
  AWAITING_SCHEDULING = 'awaiting-scheduling',
  ORDER_CREATED = 'order-created',
  CANDIDATE_REJECTED = 'candidate-rejected',
}

export { DELIVERY_CANDIDATE_STATUS }
